var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"mb-2",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-btn',{attrs:{"small":"","fab":"","elevation":"6","color":"success"},on:{"click":_vm.goToSchedule}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-calendar-search-outline ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }